import {
  NID_DETAILS_LOADING,
  NID_DETAILS_SUCCESS,
  NID_DETAILS_FAILED,
  UPLOAD_FILE_MULTIPART_LOADING_NID,
  UPLOAD_FILE_MULTIPART_SUCCESS_NID,
  UPLOAD_FILE_MULTIPART_FAILED_NID,
  SAVE_NID_DETAILS_LOADING,
  SAVE_NID_DETAILS_SUCCESS,
  SAVE_NID_DETAILS_FAILED,
  DELETE_FILE_LOADING_NID,
  DELETE_FILE_SUCCESS_NID,
  DELETE_FILE_FAILED_NID,
  NID_DETAILS_WITHOCR_LOADING,
  NID_DETAILS_WITHOCR_SUCCESS,
  NID_DETAILS_WITHOCR_FAILED,
  VERIFY_PROFILE_DATA_LOADING,
  VERIFY_PROFILE_DATA_SUCCESS,
  VERIFY_PROFILE_DATA_FAILED,
  CAPTCHA_DATA_LOADING,
  CAPTCHA_DATA_SUCCESS,
  CAPTCHA_DATA_FAILED,
  SEND_OTP_LOADING,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILED,
  VERIFY_OTP_LOADING,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILED,
  SAVE_PAN_LOADING,
  SAVE_PAN_SUCCESS,
  SAVE_PAN_FAILED
} from "../Constants/nidConstants";

export const nidDetailsReducer = (state = { nidDetailsData: [] }, action) => {
  switch (action.type) {
    case NID_DETAILS_LOADING:
      return { loading: true, nidDetailsData: [] };
    case NID_DETAILS_SUCCESS:
      return { loading: false, nidDetailsData: action.payload };
    case NID_DETAILS_FAILED:
      return { loading: false, error: action.nidDetailsData };
    default:
      return state;
  }
};
export const nidDetailsWithOCRReducer = (state = { nidDetailsWithOCRData: [] }, action) => {
  switch (action.type) {
    case NID_DETAILS_WITHOCR_LOADING:
      return { loading: true, nidDetailsWithOCRData: [] };
    case NID_DETAILS_WITHOCR_SUCCESS:
      return { loading: false, nidDetailsWithOCRData: action.payload };
    case NID_DETAILS_WITHOCR_FAILED:
      return { loading: false, error: action.nidDetailsWithOCRData };
    default:
      return state;
  }
};

export const nidUploadFilesReducer = (
  state = { nidUploadFilesData: {} },
  action
) => {
  switch (action.type) {
    case UPLOAD_FILE_MULTIPART_LOADING_NID:
      return { loading: true, nidUploadFilesData: {} };
    case UPLOAD_FILE_MULTIPART_SUCCESS_NID:
      return {
        loading: false,
        nidUploadFilesData: {
          ...state.nidUploadFilesData,
          [action.payload.uploadedFileName]: {
            preview: action.payload.preview,
            docId: action.payload.uploadedDocId,
          },
        },
      };
    case UPLOAD_FILE_MULTIPART_FAILED_NID:
      return { loading: false, error: action.nidUploadFilesData };
    default:
      return state;
  }
};

export const savenidDetailsReducer = (
  state = { saveNIDDetailsData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_NID_DETAILS_LOADING:
      return { loading: true, saveNIDDetailsData: [] };
    case SAVE_NID_DETAILS_SUCCESS:
      return { loading: false, saveNIDDetailsData: action.payload };
    case SAVE_NID_DETAILS_FAILED:
      return { loading: false, error: action.saveNIDDetailsData };
    default:
      return state;
  }
};

export const deleteUploadedFileReducer = (
  state = { deleteUploadedFileData: {} },
  action
) => {
  switch (action.type) {
    case DELETE_FILE_LOADING_NID:
      return { loading: true, deleteUploadedFileData: {} };
    case DELETE_FILE_SUCCESS_NID:
      return { loading: false, deleteUploadedFileData: action.payload };
    case DELETE_FILE_FAILED_NID:
      return { loading: false, error: action.deleteUploadedFileData };
    default:
      return state;
  }
};

export const verifyProfileChecksReducer = (
  state = { verifyProfileChecksData: {} },
  action
) => {
  switch (action.type) {
    case VERIFY_PROFILE_DATA_LOADING:
      return { loading: true, verifyProfileChecksData: {...state.verifyProfileChecksData} };
    case VERIFY_PROFILE_DATA_SUCCESS:
      return { loading: false, verifyProfileChecksData: {...state.verifyProfileChecksData,...action.payload} };
    case VERIFY_PROFILE_DATA_FAILED:
      return { loading: false, error: action.payload,verifyProfileChecksData:{...state.verifyProfileChecksData} };
    default:
      return state;
  }
};

export const generateCaptchaReducer = (
  state = { generateCaptchaReducerData: {} },
  action
) => {
  switch (action.type) {
    case CAPTCHA_DATA_LOADING:
      return { loading: true, generateCaptchaReducerData: {} };
    case CAPTCHA_DATA_SUCCESS:
      return { loading: false, generateCaptchaReducerData: action.payload };
    case CAPTCHA_DATA_FAILED:
      return { loading: false, error: action.generateCaptchaReducerData };
    default:
      return state;
  }
};

export const sendOtpReducer = (
  state = { sendOtpReducerData: {} },
  action
) => {
  switch (action.type) {
    case SEND_OTP_LOADING:
      return { loading: true, sendOtpReducerData: {} };
    case SEND_OTP_SUCCESS:
      return { loading: false, sendOtpReducerData: action.payload };
    case SEND_OTP_FAILED:
      return { loading: false, error: action.sendOtpReducerData };
    default:
      return state;
  }
};

export const verifyAOtpReducer = (
  state = { verifyOtpReducerData: {} },
  action
) => {
  switch (action.type) {
    case VERIFY_OTP_LOADING:
      return { loading: true, verifyOtpReducerData: {} };
    case VERIFY_OTP_SUCCESS:
      return { loading: false, verifyOtpReducerData: action.payload };
    case VERIFY_OTP_FAILED:
      return { loading: false, error: action.verifyOtpReducerData };
    default:
      return state;
  }
};

export const savePanReducer = (
  state = { savePanReducerData: {} },
  action
) => {
  switch (action.type) {
    case SAVE_PAN_LOADING:
      return { loading: true, savePanReducerData: {} };
    case SAVE_PAN_SUCCESS:
      return { loading: false, savePanReducerData: action.payload };
    case SAVE_PAN_FAILED:
      return { loading: false, error: action.savePanReducerData };
    default:
      return state;
  }
};
